import React, { useEffect, useState } from 'react';
import './LabPricingStyles.css';
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { useAlert } from 'react-alert';
import TestDetails from './TestDetails';
import { sampleList } from './sampleList';
import PanelShow from './PanelShow';
import TestShow from './TestShow';
import { FaPlus } from "react-icons/fa";

const Global = ({ search, refresh }) => {
  const [selectedCategory, setSelectedCategory] = useState("blood");
  const [selectedTest, setSelectedTest] = useState(null);
  const [selectedPanel, setSelectedPanel] = useState(null);
  const [addPanel, setAddPanel] = useState(false);
  const [addTest, setAddTest] = useState(false);
  const [data, setData] = useState(null);
  const alert = useAlert();
  const [previousSelectedTestId, setPreviousSelectedTestId] = useState(null);
  const [previousSelectedPanelId, setPreviousSelectedPanelId] = useState(null);

  useEffect(() => {
    handleSampleData('blood');
  }, [refresh]);

  const handleSampleData = (sample) => {
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
    const formattedSample = sample.replace(/\s+/g, '_');
    axios.get(`${APIURL}/api/v1/staff/lab-test/?sample=${formattedSample}&${TZ}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
      .then(res => {
        if (res.status === 200) {
          if (res.data.status === 'success') {
            setData(res.data);

            if (previousSelectedTestId) {
              const updatedSelectedTest = res.data.tests.find(test => test.id === previousSelectedTestId);
              setSelectedTest(updatedSelectedTest || null);
            }
            if (previousSelectedPanelId) {
              const updatedSelectedPanel = res.data.panels.find(panel => panel.id === previousSelectedPanelId);
              setSelectedPanel(updatedSelectedPanel || null);
            }
          } else {
            alert.error(res.data.message);
            setData(null)
          }
        } else {
          alert.error('Error occurred, try again');
        }
      })
      .catch(err => {
        alert.error('Error fetching sample data');
      });
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    handleSampleData(category);
    setSelectedTest(null);
    setSelectedPanel(null);
  };

  const handleItemClick = (item, type) => {
    if (type === "test") {
      if (selectedTest !== item) {
        setSelectedTest(item);
        setPreviousSelectedTestId(item.id);
      } else {
        setSelectedTest(null);
        setPreviousSelectedTestId(null);
      }
      setPreviousSelectedPanelId(null)
      setSelectedPanel(null);
    } else if (type === "panel") {
      if (selectedPanel !== item) {
        setSelectedPanel(item);
        setPreviousSelectedPanelId(item.id);
      } else {
        setSelectedPanel(null);
        setPreviousSelectedPanelId(null);
      }
      setSelectedTest(null);
      setPreviousSelectedTestId(null);
    }
  };

  const handleSuccess = () => {
    setAddPanel(false);
    setAddTest(false);
    handleSampleData(selectedCategory);
  };

  const filteredTests = data?.tests.filter(test =>
    search ? test.test_name?.toLowerCase().includes(search.toLowerCase()) : true
  ) || [];

  const filteredPanels = data?.panels.filter(panel =>
    search ? panel.panel_name?.toLowerCase().includes(search.toLowerCase()) : true
  ) || [];

  return (
    <>
      <div className="left-side-buttons" style={{ flex: (selectedPanel || selectedTest) ? 1 : 2 }}>
        <div className="left-side-buttons-title">Samples</div>
        <div className="left-side-buttons" style={{ borderRadius: 0, border: "none" }}>
          {sampleList.map((category) => (
            <button
              key={category}
              className={`category-button ${selectedCategory === category ? "active" : ""}`}
              onClick={() => handleCategoryClick(category)}
            >
              {category.replace(/_/g, ' ')}
            </button>
          ))}
        </div>
      </div>
      <div className="test-panel-column" style={{ flex: (selectedPanel || selectedTest) ? 2 : 5 }}>
        <div className="left-side-buttons-title">
          <span>Panels</span>
          <button className='add-btn' onClick={() => { setAddPanel(!addPanel) }} style={{ backgroundColor: 'rgb(164, 154, 215)' }}><FaPlus /> Panel</button>
        </div>
        <div className="panel-box">
          <div className="panel-widgets">
            {filteredPanels.length > 0 ? (filteredPanels.map((panel) => (
              <div
                key={panel.id}
                className={`panel-widget ${selectedPanel?.id === panel.id ? "active" : ""}`}
                onClick={() => handleItemClick(panel, "panel")}
              >
                <h3>{panel.panel_name}</h3>
              </div>))) : (
              <label style={{ color: "red" }}>No added panels!!</label>
            )
            }
          </div>
        </div>
        <div className="left-side-buttons-title" style={{ borderRadius: "0px" }}>
          <span>LabTest</span>
          <button className='add-btn' onClick={() => { setAddTest(!addTest) }} style={{ backgroundColor: 'rgb(164, 154, 215)' }}><FaPlus /> Test</button>
        </div>
        <div className="test-box">
          <div className="test-widgets">
            {filteredTests.length > 0 ? (
              filteredTests.map((test) => (
                <div
                  key={test.id}
                  className={`test-widget ${selectedTest?.id === test.id ? "active" : ""}`}
                  onClick={() => handleItemClick(test, "test")}
                >
                  <h3>{test.test_name}</h3>
                </div>
              ))
            ) : (
              <label style={{ color: "red" }}>No added tests!!</label>
            )}
          </div>
        </div>
      </div>
      <div className="pricing-details" style={{ flex: (selectedPanel || selectedTest) ? 3 : 2 }}>
        <div className="left-side-buttons-title"> Test Details</div>
        {selectedTest && <TestDetails type='global' selected={"test"} selectedTest={selectedTest} data={data} handleSuccess={handleSuccess} sample={selectedCategory} />}
        {selectedPanel && <TestDetails type='global' selected={"panels"} selectedTest={selectedPanel} data={data} handleSuccess={handleSuccess} sample={selectedCategory} />}
      </div>
      {addPanel && <PanelShow type='global' testGroup={selectedCategory} handleSuccess={handleSuccess} onClose={() => { setAddPanel(false) }} />}
      {addTest && <TestShow type='global' testGroup={selectedCategory} handleSuccess={handleSuccess} onClose={() => { setAddTest(false) }} />}

    </>
  )
}
export default Global